class PickerFollowingListItemFactory {
  constructor({
    apiUrl,
    customerId,
  }) {
    this.customerId = customerId
    this.apiUrl = apiUrl
  }

  createElement({ imageSrc, title, productsCount, pickerId, handle, isFollowing, isNew }) {
    const element = document.createElement('li');
    element.className = 'following-picker-card-item';

    // aタグを作成
    const content = document.createElement('div');
    content.className = `following-picker-card ${handle}`;

    const link = document.createElement('a');
    link.className = 'following-picker-card__content';
    link.setAttribute('data-picker-handle', handle);
    link.href = `/collections/${handle}`;

    const img = document.createElement('img');
    img.className = 'following-picker-card__image' + (isNew ? ' following-picker-card__image--new' : '');
    img.src = imageSrc;
    img.alt = title;
    img.width = 100;
    img.height = 100;

    const contentInner = document.createElement('div');
    contentInner.className = 'following-picker-card__content-inner';

    const titleElement = document.createElement('h3');
    titleElement.className = 'following-picker-card__title py-lineclamp-1';
    titleElement.innerText = title;

    const productsCountElement = document.createElement('span');
    productsCountElement.className = 'following-picker-card__products-count py-lineclamp-1';
    productsCountElement.innerText = productsCount >= 50 ? `出品中のアイテム：50点以上` : `出品中のアイテム：${productsCount}点`;

    contentInner.appendChild(titleElement);
    contentInner.appendChild(productsCountElement);
    link.appendChild(img);
    link.appendChild(contentInner);

    // imgとcontentをaタグに追加
    content.appendChild(link);

    const followButton = new PickerFollowButtonFactory({
      customerId: this.customerId,
      pickerId: pickerId,
      pickerName: title,
      isFollowing,
      pickerHandle: handle,
      followPickerApiUrl: this.apiUrl,
    }).button;
    content.appendChild(followButton);

    // li要素にaタグを追加
    element.appendChild(content);

    return element;
  }
}
